import { fileUploadConstants } from "../constants";
import { fileUploaderService } from "../services";
import { alertActions } from "./alert.actions";

export const fileUploaderActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  addProfileImage,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    fileUploaderService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: fileUploadConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: fileUploadConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: fileUploadConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(file) {
  return (dispatch) => {
    dispatch(request(file));

    fileUploaderService.addParameter(file).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: fileUploadConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fileUploadConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fileUploadConstants.ADD_FAILURE, error };
  }
}

// add parameter
function addProfileImage(file) {
  return (dispatch) => {
    dispatch(request(file));

    fileUploaderService.addProfileImage(file).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: fileUploadConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fileUploadConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fileUploadConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    fileUploaderService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: fileUploadConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fileUploadConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fileUploadConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    fileUploaderService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: fileUploadConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: fileUploadConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: fileUploadConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: fileUploadConstants.CLEAR };
}
